export type Language = "en" | "vi"

export const translations = {
  en: {
    // Header
    features: "Features",
    models: "AI Products",
    pricing: "Pricing",
    docs: "Documentation",
    privacy: "Privacy",
    terms: "Terms",
    signIn: "Sign In",
    getStarted: "Get Started",

    // Hero
    newGenPlatform: "Next Generation AI Platform",
    heroTitle: "The Most Powerful AI Platform for Businesses",
    heroDescription:
      "Build breakthrough AI experiences with industry-leading models and advanced tools. Automate workflows, optimize performance, and drive innovation.",
    startNow: "Start Now",
    viewDemo: "View Demo",
    trustedBy: "Trusted by over 10,000+ businesses worldwide",

    // Features
    featuresTitle: "Outstanding Features",
    featuresSubtitle: "Discover powerful features that help your business lead in the AI era",
    advancedModels: "Advanced AI Models",
    advancedModelsDesc: "Access top AI models with superior performance and high accuracy.",
    fastProcessing: "Fast Processing Speed",
    fastProcessingDesc: "Real-time data processing and response with lowest latency.",
    absoluteSecurity: "Absolute Security",
    absoluteSecurityDesc: "Data encryption and compliance with international security standards.",
    easyAPI: "Easy API Integration",
    easyAPIDesc: "Seamlessly integrate with existing systems with just a few lines of code.",
    detailedAnalytics: "Detailed Analytics",
    detailedAnalyticsDesc: "Track performance and optimize with comprehensive analytics dashboard.",
    multiLanguage: "Multi-language Support",
    multiLanguageDesc: "Process and understand over 100 different languages worldwide.",

    // Models
    modelsTitle: "Our AI Products",
    modelsSubtitle: "Specialized AI solutions for your creative and business needs",
    mostPopular: "Most Popular",

    musicAIName: "3B Music AI",
    musicAIDesc: "AI-powered music generation and editing",
    musicComposition: "AI music composition",
    audioEnhancement: "Audio enhancement",
    soundDesign: "Sound design & mixing",

    photoAIName: "3B Photo AI",
    photoAIDesc: "Professional photo editing with AI",
    imageEnhancement: "Image enhancement",
    backgroundRemoval: "Background removal",
    styleTransfer: "Style transfer & effects",

    emailAIName: "3B Email AI",
    emailAIDesc: "Smart email writing and management",
    emailGeneration: "Email generation",
    toneAdjustment: "Tone adjustment",
    autoResponse: "Auto-response suggestions",

    videoAIName: "3B Video AI",
    videoAIDesc: "AI video editing and production",
    videoEditing: "AI video editing",
    sceneDetection: "Scene detection",
    autoSubtitles: "Auto subtitles",

    voiceAIName: "3B Voice AI",
    voiceAIDesc: "Voice synthesis and recognition",
    voiceCloning: "Voice cloning",
    speechToText: "Speech to text",
    textToSpeech: "Text to speech",

    designAIName: "3B Design AI",
    designAIDesc: "AI-powered design assistant",
    logoGeneration: "Logo generation",
    layoutSuggestions: "Layout suggestions",
    colorPalettes: "Color palette creation",

    // CTA
    ctaTitle: "Ready to Transform Your Business?",
    ctaDescription: "Join thousands of businesses using 3BproductAI to accelerate digital transformation",
    startFreeTrial: "Start Free Trial",
    contactSales: "Contact Sales",

    // Footer
    footerTagline: "Leading AI platform for Vietnamese businesses",
    copyright: "© 2025 3B Company. All rights reserved.",
  },
  vi: {
    // Header
    features: "Tính năng",
    models: "Sản phẩm AI",
    pricing: "Giá cả",
    docs: "Tài liệu",
    privacy: "Bảo mật",
    terms: "Điều khoản",
    signIn: "Đăng nhập",
    getStarted: "Bắt đầu",

    // Hero
    newGenPlatform: "Nền tảng AI thế hệ mới",
    heroTitle: "Nền tảng AI mạnh mẽ nhất cho doanh nghiệp",
    heroDescription:
      "Xây dựng các trải nghiệm AI đột phá với mô hình công nghiệp hàng đầu và công cụ tiên tiến. Tự động hóa quy trình, tối ưu hiệu suất và thúc đẩy đổi mới.",
    startNow: "Bắt đầu ngay",
    viewDemo: "Xem Demo",
    trustedBy: "Được tin dùng bởi hơn 10,000+ doanh nghiệp toàn cầu",

    // Features
    featuresTitle: "Tính năng vượt trội",
    featuresSubtitle: "Khám phá những tính năng mạnh mẽ giúp doanh nghiệp của bạn dẫn đầu trong kỷ nguyên AI",
    advancedModels: "Mô hình AI tiên tiến",
    advancedModelsDesc: "Truy cập vào các mô hình AI hàng đầu với hiệu suất vượt trội và độ chính xác cao.",
    fastProcessing: "Tốc độ xử lý nhanh",
    fastProcessingDesc: "Xử lý dữ liệu và phản hồi trong thời gian thực với độ trễ thấp nhất.",
    absoluteSecurity: "Bảo mật tuyệt đối",
    absoluteSecurityDesc: "Mã hóa dữ liệu và tuân thủ các tiêu chuẩn bảo mật quốc tế.",
    easyAPI: "API dễ tích hợp",
    easyAPIDesc: "Tích hợp liền mạch với hệ thống hiện có chỉ với vài dòng code.",
    detailedAnalytics: "Phân tích chi tiết",
    detailedAnalyticsDesc: "Theo dõi hiệu suất và tối ưu hóa với dashboard phân tích toàn diện.",
    multiLanguage: "Hỗ trợ đa ngôn ngữ",
    multiLanguageDesc: "Xử lý và hiểu hơn 100 ngôn ngữ khác nhau trên toàn thế giới.",

    // Models
    modelsTitle: "Sản phẩm AI của chúng tôi",
    modelsSubtitle: "Giải pháp AI chuyên biệt cho nhu cầu sáng tạo và kinh doanh của bạn",
    mostPopular: "Phổ biến nhất",

    musicAIName: "3B Music AI",
    musicAIDesc: "Sáng tác và chỉnh sửa nhạc bằng AI",
    musicComposition: "Sáng tác nhạc AI",
    audioEnhancement: "Nâng cao chất lượng âm thanh",
    soundDesign: "Thiết kế & mix âm thanh",

    photoAIName: "3B Photo AI",
    photoAIDesc: "Chỉnh sửa ảnh chuyên nghiệp với AI",
    imageEnhancement: "Nâng cao chất lượng ảnh",
    backgroundRemoval: "Xóa phông nền",
    styleTransfer: "Chuyển đổi phong cách & hiệu ứng",

    emailAIName: "3B Email AI",
    emailAIDesc: "Viết và quản lý email thông minh",
    emailGeneration: "Tạo email tự động",
    toneAdjustment: "Điều chỉnh giọng điệu",
    autoResponse: "Gợi ý trả lời tự động",

    videoAIName: "3B Video AI",
    videoAIDesc: "Chỉnh sửa và sản xuất video AI",
    videoEditing: "Chỉnh sửa video AI",
    sceneDetection: "Phát hiện cảnh",
    autoSubtitles: "Phụ đề tự động",

    voiceAIName: "3B Voice AI",
    voiceAIDesc: "Tổng hợp và nhận dạng giọng nói",
    voiceCloning: "Nhân bản giọng nói",
    speechToText: "Chuyển giọng nói thành văn bản",
    textToSpeech: "Chuyển văn bản thành giọng nói",

    designAIName: "3B Design AI",
    designAIDesc: "Trợ lý thiết kế bằng AI",
    logoGeneration: "Tạo logo",
    layoutSuggestions: "Gợi ý bố cục",
    colorPalettes: "Tạo bảng màu",

    // CTA
    ctaTitle: "Sẵn sàng chuyển đổi doanh nghiệp?",
    ctaDescription: "Tham gia cùng hàng nghìn doanh nghiệp đang sử dụng 3BproductAI để tăng tốc chuyển đổi số",
    startFreeTrial: "Dùng thử miễn phí",
    contactSales: "Liên hệ bán hàng",

    // Footer
    footerTagline: "Nền tảng AI hàng đầu cho doanh nghiệp Việt Nam",
    copyright: "© 2025 3B Company. Tất cả quyền được bảo lưu.",
  },
} as const
